<template>
  <v-app-bar dark flat inset color="#4BA0B2">
    <v-toolbar-title class="text-list"
      ><span @click="home()" style="font-size: 34px; cursor: pointer;"
        >KanP<u>ramoo</u>l.com</span
      ></v-toolbar-title
    >
    <v-spacer></v-spacer>
    <span style="font-size: 18px;" v-if="isLogin"
      ><v-icon class="mr-2" light style="color: #fff">mdi-account-key</v-icon
      >{{ fullname }}</span
    ><v-icon class="ml-2" light style="color: #fff"
      >mdi-chevron-down-circle</v-icon
    >
  </v-app-bar>
</template>

<script>
export default {
  name: "navbarBox",
  data: () => ({
    fullname: "",
    isLogin: false,
  }),
  created() {
    if (localStorage.getItem("username") === null) {
      this.isLogin = false;
    } else {
      this.isLogin = true;
    }
  },
  mounted() {
    if (window.location.pathname === "/login") {
      if (localStorage.getItem("username") !== null) {
        this.$router.push("/homepage");
      }
    } else {
      if (localStorage.getItem("username") === null) {
        this.$router.push("/login");
      } else {
        this.fullname = localStorage.getItem("fullname");
      }
    }
  },
  methods: {
    home() {
      this.$router.push("/homepage");
    },
  },
};
</script>
